import React from 'react'
import { Link } from 'react-router-dom'
import logo from '../logo.svg'

const Navbar = () => {
  return (
    <nav className='nav-bar'>
      <div className='nav-center'>
        <Link to='/'>
          <img src={logo} alt='logo' className='logo' />
        </Link>
        <ul className='nav-links'>
          <li>
            <Link to='/About'>About</Link>
          </li>
          <li>
            <Link to='/'>Home</Link>
          </li>
        </ul>
      </div>
    </nav>
  )
}

export default Navbar
